module.exports = __webpack_public_path__ + "ea1f2a3039f1eb7e66621b45cc24dc78.png";